import { Avatar } from "@mui/material";

function PlayerAvatar({ sleeper_id, first_name, last_name, size = "30px" }) {
  // Handle responsive size object or string
  const sizeStyle = typeof size === 'object' ? size : { width: size, height: size };
  
  return (
    <Avatar
      src={`https://sleepercdn.com/content/nfl/players/${sleeper_id}.jpg`}
      alt={`${first_name} ${last_name}`}
      variant="rounded"
      sx={{
        ...sizeStyle,
        margin: 0,
      }}
    />
  );
}

export default PlayerAvatar;
